module.exports = __webpack_public_path__ + "static/media/black-matte.ca71a61d.png";